import React, { Component } from "react";
import axios from "axios";
import Empty from "../image/empty.svg"
import { MdOutlineFileDownload } from "react-icons/md";
import { MdOutlineDeleteOutline } from "react-icons/md";
import { FaRegEdit } from "react-icons/fa";



class CourseVideo extends Component {
    state = {
        course: [],
        windowWidth: window.innerWidth,
        currentVideo: [],
        editingTitleVideoId: null,
        editingOrderVideoId: null,
        editedTitles: {},
        editedOrders: {},
        thumbnailUrl: null, // Add thumbnail state
        showThumbnail: true, // Add showThumbnail state
    }
    videoRef = React.createRef();
    handleAddvideo = () => {
        const formcontainer = document.querySelector(".dash_add_course_cover.addvideo")
        formcontainer.style.display = "flex"
    }

    componentDidMount() {
        this.fetchCourses();
        window.addEventListener('resize', this.handleResize); // Add resize listener
    }

    componentWillUnmount() {
        window.removeEventListener('resize', this.handleResize); // Remove listener
    }
    handleResize = () => {
        this.setState({ windowWidth: window.innerWidth }); // Update window width on resize
    };
    componentDidUpdate(prevProps, prevState) {
        if (this.props.shouldRefresh && this.props.shouldRefresh !== prevProps.shouldRefresh) {
            this.fetchCourses();
            this.props.onRefreshDone();
        }
        if (this.state.currentVideo !== prevState.currentVideo && this.videoRef.current) {
            this.videoRef.current.load();
        }
        if (this.props.course_id !== prevProps.course_id) {
            this.fetchCourses();
        }
        if (this.state.course.videos && this.state.course.videos.length > 0 && !prevState.course.videos) {
            this.setInitialVideo();
        }
    }

    setInitialVideo = () => {
        const firstVideo = this.state.course.videos[0];
        if (firstVideo) {
            this.setState({
                currentVideo: firstVideo,
                thumbnailUrl: firstVideo.thumbnail,
            });
        }
    };
    fetchCourses = async () => {
        const accessToken = localStorage.getItem("accessToken");

        try {
            const course_id = this.props.course_id
            const courseId = parseInt(course_id, 10);
            const response = await axios.get("https://api.geoinfoacademy.com/api/tutor/courses/" + courseId, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });
            this.setState({ course: response.data });
            console.log("API Response:", response.data);
        } catch (error) {
            console.error("Error fetching data:", error);
        }
    };
    handleDownload = async (video) => {
        const accessToken = localStorage.getItem("accessToken");
        const documentId = video.id; // Assuming your document object has an 'id' property

        try {
            const response = await axios.get(`https://api.geoinfoacademy.com/api/download/video/${documentId}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
                responseType: 'blob', // Important: Specify response type as blob
            });

            // Create a blob URL for the downloaded file
            const blob = new Blob([response.data], { type: response.headers['content-type'] }); // Get the content type from the response
            const url = window.URL.createObjectURL(blob);

            // Create a temporary link and trigger the download
            const link = document.createElement('a');
            link.href = url;

            // Extract filename from Content-Disposition header if available, else use the title.
            let filename = video.title; // Default filename (if all else fails)

            const contentDisposition = response.headers['content-disposition'];

            if (contentDisposition) {
                // 1. Try to get filename from Content-Disposition header (BEST option)
                const filenameMatch = contentDisposition.match(/filename="(.+)"/);
                if (filenameMatch) {
                    filename = filenameMatch[1]; // Use filename from header
                }
            } else if (video.file_path) {
                // 2. If Content-Disposition is missing, try to guess from doc.file_path (LESS reliable)
                try {  // Add a try-catch in case doc.file_path is malformed
                    const url = new URL(video.file_path); // Use URL object for robust parsing
                    const pathname = url.pathname;
                    const ext = pathname.substring(pathname.lastIndexOf('.') + 1); // Extract extension

                    if (ext) {
                        filename = `${video.title}.${ext}`; // Add guessed extension to title
                    } else {
                        console.warn("Could not determine extension from doc.file_path:", video.file_path);
                    }

                } catch (error) {
                    console.error("Error parsing doc.file_path:", video.file_path, error);
                }
            } else {
                console.warn("Neither Content-Disposition nor doc.file_path available for filename.");
            }


            link.setAttribute('download', filename); // Set the filename
            document.body.appendChild(link);
            link.click();
            link.remove();
            window.URL.revokeObjectURL(url);

        } catch (error) {
            console.error("Error downloading file:", error);
        }
    };
    handleDelete = async (video) => {
        const accessToken = localStorage.getItem("accessToken");


        try {
            const response = await axios.delete(`https://api.geoinfoacademy.com/api/tutor/videos/${video.id}/`, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            });

            if (response.status === 204 || response.status === 200) { // Check for successful delete status codes (204 No Content is common)
                console.log("Document deleted successfully:", video.id);
                // Optionally: Refresh the document list after successful deletion
                this.fetchCourses(); // Or whatever method you use to refresh the list
                // You might also want to provide user feedback (e.g., a toast notification)
                // alert("Document deleted successfully")
            } else {
                console.error("Error deleting document:", response.status, response.data);
                // Handle error (e.g., display an error message to the user)
                alert("Error deleting document")

            }
        } catch (error) {
            console.error("Error deleting document:", error);
            // Handle network errors or other exceptions
            alert("Error deleting document")
        }
    };



    handleVideoClick(video) {
        this.setState({ currentVideo: video, showThumbnail: false });
    }





    startEditingTitle = (videoId) => {
        this.setState({
            editingTitleVideoId: videoId,
            editedTitles: { ...this.state.editedTitles, [videoId]: this.state.editedTitles[videoId] || this.state.course.videos.find(v => v.id === videoId).title },
        });
    };
    
    startEditingOrder = (videoId) => {
        this.setState({
            editingOrderVideoId: videoId,
            editedOrders: { ...this.state.editedOrders, [videoId]: this.state.editedOrders[videoId] || this.state.course.videos.find(v => v.id === videoId).order },
        });
    };
    
    handleTitleChange = (videoId, value) => {
        this.setState({
            editedTitles: { ...this.state.editedTitles, [videoId]: value },
        });
    };
    
    handleOrderChange = (videoId, value) => {
        this.setState({
            editedOrders: { ...this.state.editedOrders, [videoId]: value },
        });
    };
    
    handleBlur = (videoId, field) => {
        this.submitChanges(videoId, field);
    };
    
    handleKeyDown = (videoId, field, e) => {
        if (e.key === "Enter") {
            this.submitChanges(videoId, field);
        }
    };
    
    submitChanges = (videoId, field) => {
        const accessToken = localStorage.getItem("accessToken");
        const updatedValue = field === "title" ? this.state.editedTitles[videoId] : this.state.editedOrders[videoId];
    
        axios
            .patch(`https://api.geoinfoacademy.com/api/tutor/videos/${videoId}/`, { [field]: updatedValue }, {
                headers: {
                    Authorization: `Bearer ${accessToken}`,
                },
            })
            .then(() => {
                this.setState({ editingTitleVideoId: null, editingOrderVideoId: null });
                this.fetchCourses();
            })
            .catch((error) => {
                console.error("Error updating video:", error);
            });
    };






    render() {
        console.log("checking current video", this.state.currentVideo)
        const video = this.state.course;
        const videoCount = video && video.videos ? video.videos.length : 1;
        const videolist = video && video.videos && video.videos.length ? (
            video.videos.map((video) => {
                const isEditingTitle = this.state.editingTitleVideoId === video.id;
                const isEditingOrder = this.state.editingOrderVideoId === video.id;
                const editedTitle = this.state.editedTitles[video.id] || video.title;
                const editedOrder = this.state.editedOrders[video.id] || video.order;
                return (
                    <div className="course_cover video" key={video.id} >
                        <button className="switch" onClick={() => this.handleVideoClick(video)}>
                            <div className="image" >
                                <img src={video.thumbnail} alt={"video" + video.id} />
                            </div>
                        </button>
                        <div className="about">
                            <h4>
                                <span>{this.state.course.labels}</span><br />
                                {isEditingTitle ? (
                        <input
                            type="text"
                            value={editedTitle}
                            onChange={(e) => this.handleTitleChange(video.id, e.target.value)}
                            onBlur={() => this.handleBlur(video.id, "title")}
                            onKeyDown={(e) => this.handleKeyDown(video.id, "title", e)}
                            autoFocus
                        />
                    ) : (
                        <>
                            {video.title}
                            <button onClick={() => this.startEditingTitle(video.id)} className="change"><FaRegEdit /></button>
                        </>
                    )}
                            </h4>
                            <p><button onClick={() => this.handleDownload(video)} className="download"><MdOutlineFileDownload /></button><button onClick={() => this.handleDelete(video)} className="download"><MdOutlineDeleteOutline /></button> </p>
                            {isEditingOrder ? (
                    <input
                        type="number"
                        value={editedOrder}
                        onChange={(e) => this.handleOrderChange(video.id, e.target.value)}
                        onBlur={() => this.handleBlur(video.id, "order")}
                        onKeyDown={(e) => this.handleKeyDown(video.id, "order", e)}
                        autoFocus
                    />
                ) : (
                    <button className="edit" onClick={() => this.startEditingOrder(video.id)}>
                        {video.order}
                    </button>
                )}
                        </div>

                    </div>
                );
            })
        ) : (
            <div className="empty_video" >
                <img src={Empty} alt="empty" />
                <h4>No Video</h4>
            </div>
        );
        const { currentVideo, thumbnailUrl, showThumbnail } = this.state;

        const scrollWidth = this.state.windowWidth < 1000 ? 300 * videoCount : "auto";
        return (
            <section className="describe_video_container" >
                <h3>Course Videos <button onClick={this.handleAddvideo} className="add">Add Video</button></h3>
                <div className="video_view">
                    {currentVideo ?  (
                        showThumbnail ? (
                            <img src={thumbnailUrl} alt="Video Thumbnail" onClick={() => this.setState({ showThumbnail: false })} style={{ cursor: 'pointer', maxWidth: '100%', minHeight: '300px' }}/>
                        ) : (
                        <video controls height="300" ref={this.videoRef} autoPlay>
                            <source src={currentVideo.file_path} type="video/mp4" />
                        </video>
                    ) ) : (
                        <p>No video selected.</p>
                    )}
                </div>
                <div className="list_course_video">
                    <div className="course_scroll" style={{ width: scrollWidth }}>
                        {/* <div className="course_cover">
                            <div className="image">

                            </div>
                            <div className="about">
                                <h4>
                                    <span>GIS</span><br />
                                    Unit Testing in Python
                                </h4>
                                <p>#30,000</p><button>1</button>
                            </div>

                        </div>
                        <div className="course_cover">
                            <div className="image">

                            </div>
                            <div className="about">
                                <h4>
                                    <span>GIS</span><br />
                                    Unit Testing in Python
                                </h4>
                                <p>#30,000</p><button>2</button>
                            </div>

                        </div>
                        <div className="course_cover">
                            <div className="image">

                            </div>
                            <div className="about">
                                <h4>
                                    <span>GIS</span><br />
                                    Unit Testing in Python
                                </h4>
                                <p>#30,000</p><button>3</button>
                            </div>

                        </div>
                        <div className="course_cover">
                            <div className="image">

                            </div>
                            <div className="about">
                                <h4>
                                    <span>GIS</span><br />
                                    Unit Testing in Python
                                </h4>
                                <p>#30,000</p><button>4</button>
                            </div>

                        </div>
                        <div className="course_cover">
                            <div className="image">

                            </div>
                            <div className="about">
                                <h4>
                                    <span>GIS</span><br />
                                    Unit Testing in Python
                                </h4>
                                <p>#30,000</p><button>5</button>
                            </div>

                        </div>
                        <div className="course_cover">
                            <div className="image">

                            </div>
                            <div className="about">
                                <h4>
                                    <span>GIS</span><br />
                                    Unit Testing in Python
                                </h4>
                                <p>#30,000</p><button>6</button>
                            </div>

                        </div> */}
                        {videolist}
                    </div>

                </div>
                {/* <div className="video_comment">
                    <h3>Comment section</h3>
                    <textarea placeholder="Any questions?" />
                </div> */}
            </section>

        )
    }
}

export default CourseVideo